import { HTTP } from '@/api/http-common'
import { HttpFunctions } from '@/api/http-functions'

export default {
  getCurrencyListAPI (callback) {
    HTTP.get('properties/currency').then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 403) {
        console.log('Error: pdo error missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      console.log(e)
    })
  },
  getCurrentCurrencyIdAPI (callback) {
    HTTP.get('properties/currency/account').then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 403) {
        console.log('Error: pdo error missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      console.log(e)
    })
  },
  setCurrentCurrencyIdAPI (callback, param) {
    if (param !== undefined) {
      HTTP.put('properties/currency', param).then(response => {
        if (response.status === 200) {
          callback(response)
        } else if (response.status === 403) {
          console.log('Error: pdo error missing')
        } else if (response.status === 401) {
          HttpFunctions.response401()
        }
      }).catch(e => {
        console.log(e)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/currencies/index.js